module.exports = __webpack_public_path__ + "static/omkar-ae920d3db97c1870cf8b9a9561fa39ca.png";